import { ContextMenu } from './context.menu.model';

export class Context {
  display: boolean = false;
  x: number = 0;
  y: number = 0;
  menus: ContextMenu[] = [];
}
